import {Injectable, inject} from "@angular/core";
import {
  FeatureFlagAdapter as ExternalFeatureFlagService
} from "../../../../../shared/infrastructure/adapters/feature-flag.adapter";
import {TicketFlags} from "../../../../../pages/service/pages/account-page/enum/ticket-flags.enum";
import {PaymentFeatureFlagService} from "../../domain/ports/payment-feature-flags";

@Injectable({
  providedIn: 'root'
})
export class PaymentFeatureFlagAdapter extends PaymentFeatureFlagService {
  private readonly featureFlags = inject(ExternalFeatureFlagService);

  isInvoiceEnabled(): boolean {
    return this.featureFlags.isFlagActivated(TicketFlags.ROLLOUT_POS_INVOICE_MODULE);
  }
}
